import { FunctionComponent } from 'react';
import { cn } from '@/utils/cn';

/**
 * Marca de lo que viene con Addon Pro (antes «Pro» y «Finanzas Pro»): una estrellita en el azul de la
 * marca. Reemplaza al punto azul del rail y acompaña, sin gritar, el título de cada
 * pantalla de Pro. El texto para lectores de pantalla va adentro; la estrella es decorativa.
 */
export interface ProStarProps {
  /** `xs`: esquina del ícono en el rail. `sm`: al lado de una etiqueta. `md`: al lado de un título. */
  size?: 'xs' | 'sm' | 'md';
  /** Texto para lectores de pantalla. `null` cuando el contexto ya dice «Pro» en voz alta. */
  label?: string | null;
  /** Contorno del color de la tarjeta: separa la estrella cuando se apoya sobre un ícono. */
  ring?: boolean;
  className?: string;
}

const SIZE: Record<NonNullable<ProStarProps['size']>, string> = {
  xs: 'h-2 w-2',
  sm: 'h-2.5 w-2.5',
  md: 'h-3.5 w-3.5'
};

export const ProStar: FunctionComponent<ProStarProps> = ({
  size = 'sm',
  label = ' (incluido en el Addon Pro)',
  ring = false,
  className
}) => (
  <>
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      className={cn(
        'inline-block shrink-0 fill-frost-brand',
        ring && 'stroke-frost-card [paint-order:stroke] [stroke-width:5px]',
        SIZE[size],
        className
      )}
    >
      <path
        d="M12 1.8l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.9l-6.4 3.5L7 14.3l-5.3-5 7.2-.9z"
        strokeLinejoin="round"
      />
    </svg>
    {label && <span className="sr-only">{label}</span>}
  </>
);

export default ProStar;
